// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"26105ba6","72":"b906f38f","104":"5d769c37","192":"99fdb525","301":"29d9bf8e","361":"4de5aac9","587":"629b6dcd","726":"ce4ed16d","900":"66f66440"}[chunkId] + ".chunk.js";
};